import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { image2 } from '../../images'
// import { meblack } from '../../images'
import Facts from './Facts'
import "./Header.css"
import { resume } from '../../images/'

const Header = () => {
    const container = useRef();
    gsap.registerPlugin(useGSAP)
    //const timeline = gsap.timeline();

    useGSAP(()=>{
       gsap.fromTo(".profile__photo__container",{
        scale:0.5,
        duration:1,
        opacity:0.5,
      },
      {
        scale:1,
        duration:1,
        ease:"sine.in",
        opacity:1,
      })
      gsap.from('.intro__text',{
        fontSize:100,
        duration:1,
        delay:1,
        ease:"sine.in",
      })
      const timeline = gsap.timeline();
      timeline
      .from(".header__info__top",{
        opacity:0,
      })
      .from(".header__title",{
        opacity:0,
        y:-30,
      })
      .from(".header__decription",{
        opacity:0,
      })
      .from(".btn",{
        x:-40,
        opacity:0,
        stagger:.5,
      })
    },{scope:container});
  return (
    <header id="header" className='blur-effect' ref={container}>
        <div className="stroke__text intro__text">HELLO</div>
      <div className="section__wrapper header__container">
        <div className="column intro__container blur-effect">
           <div className="header__info">
                <div className="header__info__top">
                   Hello There! I'm <span className="color__primary">A WEB DEVELOPER</span>
                </div>
                <div className="header__info__middle">
                    <h1 className="primary__title header__title">I'M Mohit Kholiya</h1>
                    <p className="header__decription text__muted">I dissect intricate user experience challenges to engineer integrity-focused solutions that resonate with billions of users.</p>
                </div>
                <Facts/>
                <div className="header__info__bottom">
                      <a href={resume} target="_blank" className="btn">Download CV</a>

                      <a href="mailto:mohitkh22@gmail.com" className="btn">Email Me</a>
                </div>
           </div>
        </div>
        <div className="column profile__wrapper">
          <div className="profile__photo__container">
               <img src={image2} alt="" className='profile__photo'/>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header